import { render, staticRenderFns } from "./OrderedByPicker.vue?vue&type=template&id=a7a05b76&scoped=true"
import script from "./OrderedByPicker.vue?vue&type=script&lang=ts"
export * from "./OrderedByPicker.vue?vue&type=script&lang=ts"
import style0 from "./OrderedByPicker.vue?vue&type=style&index=0&id=a7a05b76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a05b76",
  null
  
)

export default component.exports